var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: "修改学生",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "80px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "name", label: "名称" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { placeholder: "请输入", autocomplete: "off" },
                model: {
                  value: _vm.formData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "phone", label: "电话" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { placeholder: "请输入", autocomplete: "off" },
                model: {
                  value: _vm.formData.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "phone", $$v)
                  },
                  expression: "formData.phone"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "school", label: "学校" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { placeholder: "请输入", autocomplete: "off" },
                model: {
                  value: _vm.formData.school,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "school", $$v)
                  },
                  expression: "formData.school"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "id_card", label: "身份证号" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { placeholder: "请输入", autocomplete: "off" },
                model: {
                  value: _vm.formData.id_card,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "id_card", $$v)
                  },
                  expression: "formData.id_card"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "password", label: "密码" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { placeholder: "不填写即不修改", autocomplete: "off" },
                model: {
                  value: _vm.formData.password,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "password", $$v)
                  },
                  expression: "formData.password"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "account", label: "账号" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { placeholder: "不填写即不修改", autocomplete: "off" },
                model: {
                  value: _vm.formData.account,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "account", $$v)
                  },
                  expression: "formData.account"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "status", label: "状态" }
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formData.status,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "status", $$v)
                    },
                    expression: "formData.status"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("启用")
                  ]),
                  _c("el-radio", { attrs: { label: 0, border: "" } }, [
                    _vm._v("禁用")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "division_ids", label: "赛区" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择赛区"
                  },
                  model: {
                    value: _vm.formData.division_ids,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "division_ids", $$v)
                    },
                    expression: "formData.division_ids"
                  }
                },
                _vm._l(_vm.divisionAllist, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }